import Vue from 'vue';

if (document.querySelector('#referrals-page')) {


    Vue.component('InvitationForms', require('./Invitations').default);
    Vue.component('ReferralsList', require('./List').default);
    new Vue({
        name: 'Referrals',
        el: '#referrals-page',
    });
}
